export const GENERAL_ERROR_HEADING = 'Sorry, something went wrong';
export const GENERAL_ERROR_BEGINNING_TEXT = 'Unable to load page. Please';
export const GENERAL_ERROR_LINK_TEXT = 'try again';
export const GENERAL_ERROR_MIDDLE_TEXT = 'or contact us at';
export const GENERAL_ERROR_ENDING_TEXT = 'for assistance.';
